"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnStyledBackdrop = exports.Backdrop = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Backdrop = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tposition: fixed;\n\tbackground: ", ";\n\tbackdrop-filter: ", ";\n\tdisplay: flex;\n\talign-items: ", ";\n\tjustify-content: ", ";\n\theight: 100vh;\n\twidth: 100vw;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tz-index: 99999;\n\t", ";\n\ttransition: opacity ease-in-out 500ms;\n\t", "\n\t", "\n"])), function (props) {
  return props.withBackdrop ? 'rgba(0, 0, 0, 0.1)' : '';
}, function (props) {
  return props.withBackdrop ? 'blur(10px)' : '';
}, function (props) {
  return props.center && 'center';
}, function (props) {
  return props.center && 'center';
}, function (_ref) {
  var open = _ref.open;
  return "opacity : ".concat(open ? '1' : '0', ";");
}, _styledSystem.position, _styledSystem.layout);
exports.Backdrop = Backdrop;
var UnStyledBackdrop = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t", "\n"])), _styledSystem.layout);
exports.UnStyledBackdrop = UnStyledBackdrop;